import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(app)/events/page.tsx");
